module.exports = __webpack_public_path__ + "img/terroir-redshift-2-mobile.fcc7bf42.jpg";